import React from 'react';
import { Button } from './BaseComponents';
import { BaseModal } from './BaseModal';

export interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSignUpClick: () => void;
  onLoginClick: () => void;
  message?: string;
  title?: string;
}

/**
 * AuthModal - A reusable authentication prompt modal
 *
 * Displays a consistent authentication prompt across the application with:
 * - Customizable message and title
 * - Lock icon for visual consistency
 * - Sign Up and Login action buttons
 * - Proper accessibility and focus management
 */
export const AuthModal: React.FC<AuthModalProps> = ({
  isOpen,
  onClose,
  onSignUpClick,
  onLoginClick,
  message = "Please sign up or log in to continue.",
  title = "Login Required"
}) => {
  return (
    <BaseModal isOpen={isOpen} onClose={onClose}>
      <div className="text-center">
        <div className="mx-auto icon-circle-lg bg-primary-50 mb-4">
          <svg className="h-8 w-8 text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-neutral-900 mb-2">{title}</h3>
        <p className="text-neutral-600 mb-6">
          {message}
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            onClick={() => {
              onClose();
              onSignUpClick();
            }}
            variant="primary"
            fullWidth={true}
            className="flex-1"
          >
            Sign Up
          </Button>
          <Button
            onClick={() => {
              onClose();
              onLoginClick();
            }}
            variant="outline"
            fullWidth={true}
            className="flex-1"
          >
            Login
          </Button>
        </div>
      </div>
    </BaseModal>
  );
};